<template>
  <div class="policy">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1 class="text-center main-color">{{ $t("Website Policy") }}</h1>
          <div class="item" v-for="(item, index) in policyData" :key="index">
            <h2 class="mt-4 main-color">
              {{ item.title }}
            </h2>
            <p v-html="item.body"></p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "websitePolicy",
  data() {
    return {
      policyData: []
    };
  },
  methods: {
    getPolicy() {
      this.$http
        .get(this.getApiUrl + "/policies", {
          headers: {
            locale: localStorage.locale
          }
        })
        .then(response => {
          this.policyData = response.data.data;
        });
    }
  },
  mounted() {
    this.getPolicy();
  }
};
</script>

<style></style>
